import Vue from "vue";
import Router from "vue-router";
import Vuex from "vuex";
import { LoadingBar } from "_c";
import routes from "./routes";
Vue.use(Router);
const index = new Router({
  mode: "history",
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

index.beforeEach((to, from, next) => {
  LoadingBar.start();
  next();
});
index.afterEach(() => {
  LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default index;
